import { buildPrimaryFetchInit } from "../../environments/primary/forgeSessionClient";
import { resolvePrimaryEnvironmentHttpUrl } from "../../environments/primary/target";

export interface CodexRuntimeReadinessHttpResult {
  readonly body: unknown;
  readonly ok: boolean;
  readonly status: number;
  readonly structuredBody: boolean;
  readonly location: string | null;
  readonly retryAfter: string | null;
  readonly requestUrl: string;
}

async function requestCodexRuntimeReadinessUrl(input: {
  readonly url: string;
  readonly method: "GET" | "POST";
  readonly signal?: AbortSignal;
}): Promise<CodexRuntimeReadinessHttpResult> {
  const response = await fetch(
    input.url,
    buildPrimaryFetchInit({
      method: input.method,
      credentials: "include",
      headers: { accept: "application/json" },
      ...(input.signal ? { signal: input.signal } : {}),
    }),
  );
  const body: unknown = await response.json().catch(() => null);
  return {
    body,
    ok: response.ok,
    status: response.status,
    structuredBody: body !== null && typeof body === "object" && !Array.isArray(body),
    location: response.headers.get("location"),
    retryAfter: response.headers.get("retry-after"),
    requestUrl: input.url,
  };
}

export function requestCodexRuntimeReadiness(input: {
  readonly runtimeId: string;
  readonly organizationId: string;
  readonly signal?: AbortSignal;
}): Promise<CodexRuntimeReadinessHttpResult> {
  const path = `/api/cmmd/forge-runtimes/${encodeURIComponent(input.runtimeId)}/provider-readiness/codex`;
  return requestCodexRuntimeReadinessUrl({
    url: resolvePrimaryEnvironmentHttpUrl(path, { organizationId: input.organizationId }),
    method: "POST",
    ...(input.signal ? { signal: input.signal } : {}),
  });
}

export function requestCodexRuntimeReadinessContinuation(input: {
  readonly url: string;
  readonly signal?: AbortSignal;
}): Promise<CodexRuntimeReadinessHttpResult> {
  return requestCodexRuntimeReadinessUrl({
    url: input.url,
    method: "GET",
    ...(input.signal ? { signal: input.signal } : {}),
  });
}
